import "./loader.scss";

export default function Loader() {
    return (
        <div className="loader-wrap">
            <div className="loader-spinner" />
        </div>
    );
}
